import type { FC } from 'react';
import { useMemo } from 'react';
import { Button } from '@patternfly/react-core/dist/dynamic/components/Button';
import { Popover } from '@patternfly/react-core/dist/dynamic/components/Popover';
import { HelpIcon } from '@patternfly/react-icons/dist/dynamic/icons/help-icon';
import type { K8sKind } from '@console/internal/module/k8s';
import { getPropertyDescription } from '@console/internal/module/k8s';
import { MarkdownView } from '@console/shared/src/components/markdown/MarkdownView';

const SCROLLABLE_POPOVER_BODY_STYLE = {
  maxHeight: '300px',
  overflowY: 'auto' as const,
};

export const SchemaFieldHelp: FC<SchemaFieldHelpProps> = ({
  model,
  propertyPath,
  headerContent,
  ariaLabel,
  fallbackDescription,
}) => {
  const description = useMemo(
    () => getPropertyDescription(model, propertyPath) || fallbackDescription,
    [model, propertyPath, fallbackDescription],
  );

  if (!description) {
    return null;
  }

  return (
    <Popover
      headerContent={headerContent}
      bodyContent={
        <div style={SCROLLABLE_POPOVER_BODY_STYLE}>
          <MarkdownView content={description} />
        </div>
      }
    >
      <Button variant="plain" aria-label={ariaLabel}>
        <HelpIcon />
      </Button>
    </Popover>
  );
};

type SchemaFieldHelpProps = {
  model: K8sKind;
  propertyPath: string | string[];
  headerContent: string;
  ariaLabel: string;
  fallbackDescription?: string;
};
